module.exports = __webpack_public_path__ + "157bd76b64bbc8c14f7ca3271bbb1d19.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-44.png
 ** module id = 1037
 ** module chunks = 0
 **/